<template>
  <div class="asktype">
    <div class="leftlist">
      <van-cell-group>
        <van-cell>
          <template slot="title">
            <span class="borderleft"></span>
            <span class="custom-title">问题类型</span>
          </template>
        </van-cell>
        <van-cell class="active">
          <template slot="title">
            <span class="borderleft"></span>
            <span class="custom-title">雷克萨斯</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="rightlist">
      <van-tabs v-model="channel" color="#3A3A3A" title-active-color="#3A3A3A" @click="Channel">
        <van-tab v-for="item in listc" :key="'listc_'+item.id" :title="item.alias" :name="item.id"></van-tab>
      </van-tabs>
      <div class="mt-20" v-if="active=='lexus'">
        <span  v-for="(item, index) in list" :key="'list_' + item.id" :class="item.active=='1'?'bkactive':'van-tags'" @click="choseTag(index,item.active,item.name)">{{item.name}}</span>
      </div>
      <div class="nobind" v-else>未选择任何品牌</div>
      <div class="btn-bott">
        <van-button color="#605C6B" size="large" @click="choiseType()">确认问题类型</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import ask from '../../../api/ask';
  import common from '../../../api/common';
  import { Row,Col,List,Button,Cell, CellGroup,Tab, Tabs,Tag  } from 'vant';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        paramsc:{
          id:5
        },
        params:{
          channel_id:5,
          column_id:'',
          is_editor:1,
        },
        active: 'lexus',
        channel:'',
        list:[],
        listc:[],
        idlist:[],
        namelist:[],
        img:{
          pic: require('../../../assets/img/lexus/1.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      var queryid=this.$route.query.idlist
      var queryname=this.$route.query.namelist
      this.params.column_id=this.$route.query.column_id
      if(queryid&&queryname){
        var ilist=JSON.parse(this.$route.query.idlist)
        var nlist=JSON.parse(this.$route.query.namelist)
        this.idlist=ilist.idlist
        this.namelist=nlist.namelist
        this.params.column_id=this.$route.query.column_id
      }
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.h = document.documentElement.clientHeight || document.body.clientHeight;
      this.getChannel()
      var params={
        event_code: '问题类型',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/Ask/AskType.vue',
        user_id: this.user.id,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){

        }
      })
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.h = document.documentElement.clientHeight || document.body.clientHeight;
      this.getChannel()
    },
    methods: {
      getChannel(){
        ask.getChannel(5).then(res => {
          if(res.data.state == 1) {
            var list=res.data.data.columns
            if(!this.params.column_id){
              this.params.column_id=list[0].id
              this.getLabels()
            }
            for(var i=0;i<list.length;i++){
              if(list[i].id==this.params.column_id){
                this.channel=i
              }else{
                this.channel=0
              }
            }
            this.listc=list
          }
        })
      },
      getLabels(){
        ask.getLabels(this.params).then(res => {
          if(res.data.state == 1) {
            var list=res.data.data
            for(var i=0;i<list.length;i++){
              list[i].active=0
            }
            var idlist=this.idlist
            if(idlist){
              for(var i=0;i<list.length;i++){
                for(var j=0;j<idlist.length;j++){
                  if(list[i].id==idlist[j]){
                    list[i].active=1
                  }
                }
              }
            }
            this.list=list
            
          }
        })
      },
      Channel(name,title){
        this.columnid=name
        this.params.column_id=name
        this.columnname=title
        this.getLabels()
      },
      ClickTree(name){
        this.active=name
      },
      choseTag(index,active,name){
        if(active){
          if(active==1){
            this.list[index].active=0
          }else{
            this.list[index].active=1
          }
        }else{
          this.list[index].active=1
        }
      },
      choiseType(){
        var list=this.list
        var idlist=[]
        var namelist=[]
        for(var i=0;i<list.length;i++){
          if(list[i].active==1){
            var id=list[i].id
            var name=list[i].name
            idlist.push(id)
            namelist.push(name)
          }
        }
        var params={
          channel_id:5,
          column_id:this.params.column_id, 
          idlist:idlist,
          namelist:namelist
        }
        this.$appService.choiseAskType(params)
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [CellGroup.name]: CellGroup,
      [Cell.name]:Cell,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]:Tag,
      [Button.name]:Button
    }
  }
</script>

<style lang="scss">
.asktype{
  .leftlist{
    width: 30%;
    float: left;
    background-color: #f8f8f8;
    .van-cell-group{
      background-color: #f8f8f8;
      min-height: 550px;
      .active{
        background-color: #fff !important;
        color: #3a3a3a !important;
        .borderleft{
          border-left: 2px solid #3a3a3a;
        }
        .custom-title{
          font-size: 12px;
          margin-left: 18px !important;
        }
      }
      .van-cell{
        padding: 12px 0;
        background-color: #f8f8f8;
        color: #9a9a9a;
        font-size: 12px;
        .custom-title{
          margin-left: 20px;
        }
      }
    }
    .van-cell:not(:last-child)::after{
      border-bottom:none;
    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      border-width:0;
    }
  }
  .rightlist{
    width: 65%;
    left: 35%;
    position: absolute;
    .nobind{
      color: #9A9A9A;
      font-size: 12px;
      text-align: center;
      margin-top: 50px;
    }
    .mt-20{
      margin-top: 20px;
    }
    .van-tags {
      display: inline-block;
      padding: 2px 20px;
      font-size: 12px;
      line-height: 1.6;
      height: 20px;
      text-align: center;
      margin: 5px;
      background-color: #F8F8F8;
      color: #9A9A9A;
      border-radius: 1.5px;
    }
    .bkactive{
      display: inline-block;
      padding: 2px 20px;
      font-size: 12px;
      line-height: 1.6;
      height: 20px;
      text-align: center;
      margin: 5px;
      background-color: #F3F9FF;
      color: #728FC4;
      border-radius: 1.5px;
    }
  }
  .van-row{
    margin-top: 10px;
  }
  .btn-bott{
    position: fixed;
    bottom: 20px;
    width: 60%;
  }
  .van-button{
    height: 40px;
    line-height: 2;
    font-size: 12px;
  }
  .listhand{
    width:40px;
    height:40px;
  }
  .membername{
    font-size: 14px;
    color: #3A3A3A;
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
    margin-top: 5px;
  }
}
</style>
